var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-order-status-box"},[_c('img',{staticClass:"ui-order-status-img",attrs:{"src":_vm.statusImg}}),_c('div',{staticClass:"ui-order-status-text"},[_vm._v(_vm._s(_vm.statusLabel)+"："+_vm._s(_vm.statusText))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }